import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const IconContainer = styled.div<{ isActive?: boolean }>`
  padding: 6px;
  border-radius: 5px;
  background-color: #f5f5f5;
  cursor: ${({ isActive }) => (!isActive ? "not-allowed" : "pointer")};
`;

export const IconContainerTrash = styled.div<{ isActive?: boolean }>`
  padding: 6px;
  border-radius: 5px;
  background-color: #f5f5f5;
  cursor: ${({ isActive }) => (!isActive ? "not-allowed" : "pointer")};

  svg {
    color: rgba(117, 117, 117) !important;
  }
`;
